import Trinity from '@core/scripts/components/trinity-adapter.js';


export const TrinityEvents = {
    sendClickHome: (clickName) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 2,
        name: 'CLICK_SERVICE_HOME',
      },
      attributes: {
        clickName: clickName,
        object: 'button',
        page: 'service',
      },
    });
  },

  sendClickMyAccount: (clickName) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 2,
        name: 'CLICK_SERVICE_SELFSERVICE_MYACCOUNT',
      },
      attributes: {
        clickName: clickName,
        object: 'button',
        page: 'service',
      },
    });
  },

    sendClickContact: (clickName, object) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 2,
        name: 'CLICK_SERVICE_CONTACT',
      },
      attributes: {
        clickName: clickName,
          object: object,
        page: 'service',
      },
    });
  },

    sendClickNavigation: (clickName) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 3,
        name: 'CLICK_SERVICE_NAVI',
      },
      attributes: {
        clickName: clickName,
        object: 'link',
        page: 'service',
      },
    });
  },

    sendClickReturn(clickName, question) {
        Trinity.sendTrinityEvent({
            schema: {
                version: 2,
                name: 'CLICK_SERVICE_RETURN'
            },
            attributes: {
                clickName: clickName,
                questionAboutReturn: question,
                object: 'button',
                page: 'service',
            }
        });
    },

    sendClickNewsletter(clickName, object) {
        Trinity.sendTrinityEvent({
            schema: {
                version: 2,
                name: 'CLICK_SERVICE_NEWSLETTER'
            },
            attributes: {
                clickName: clickName,
                object: object,
                page: 'service',
            }
        });

    },

    sendClickDelivery(clickName, object) {
        Trinity.sendTrinityEvent({
            schema: {
                version: 2,
                name: 'CLICK_SERVICE_DELIVERY_SHIPPINGCOSTS'
            },
            attributes: {
                clickName: clickName,
                object: object,
                page: 'service',
            }
        });
    },

    sendClickPayment(clickName, object) {
        Trinity.sendTrinityEvent({
            schema: {
                version: 4,
                name: 'CLICK_SERVICE_PAYMENT'
            },
            attributes: {
                clickName: clickName,
                object: object,
                page: 'service',
            }
        });
    },

    sendClickOrderChannels: (clickName) => {
        Trinity.sendTrinityEvent({
            schema: {
              version: 3,
                name: 'CLICK_SERVICE_ORDER_CHANNELS'
            },
            attributes: {
                clickName: clickName,
                object: 'button',
                page: 'service'
            }
        });
    },
};

window.TrinityEvents = TrinityEvents;
